import {
  ADISON_OFFERWALL_MIN_APP_VERSION,
  OFFERWALL_VENDOR,
} from '@/constants/offerwall';
import { isAppVersionAtLeast } from '@/utils';

//* 혜택 메뉴 항목의 placementKey는 벤더 마커(OFFERWALL_VENDOR)만 유효하다.
//* 어드민은 벤더만 고르고, 그 외 값·미지원 환경은 null → 소비처가 항목을 비활성 처리한다.

//* 세 벤더 모두 지면 식별자 없이 오퍼월을 연다. 애디슨 inventory는 벤더 규약상 옵셔널이고
//* (미전달 시 지면 정보 없이 전체 목록), 앱 브릿지가 옵셔널 param으로 받으므로
//* 콘솔에서 발급되면 앱 재빌드 없이 여기서 값을 실어주면 된다.
export type ResolvedOfferwall =
  { vendor: 'adison' } | { vendor: 'pincrux' } | { vendor: 'adpopcorn' };

export const resolveOfferwallVendor = (
  placementKey: string,
  appVersion?: string | null,
): ResolvedOfferwall | null => {
  if (placementKey === OFFERWALL_VENDOR.ADPOPCORN) {
    return { vendor: 'adpopcorn' };
  }

  //* 3.2.0 미만 앱의 네이티브 showOfferwall은 인자가 하나뿐이라 2인자 호출에서 실패한다.
  if (placementKey === OFFERWALL_VENDOR.ADISON) {
    return appVersion &&
      isAppVersionAtLeast(appVersion, ADISON_OFFERWALL_MIN_APP_VERSION)
      ? { vendor: 'adison' }
      : null;
  }

  if (placementKey === OFFERWALL_VENDOR.PINCRUX) {
    return { vendor: 'pincrux' };
  }

  return null;
};
